import React from "react";
import _isEmpty from "lodash/isEmpty";
import { connect } from "react-redux";
import { RootState } from "../../../../../../models";
import { FooterProps } from "../../../../../../models/footer";
import { useBreakpoint } from "../../../../components/hooks";
import { isCheckout as isCheckoutSelector } from "../../../../app/state/selectors";
import * as NAVIGATION_SELECTORS from "../../../state/selectors";
import DesktopFooter from "./DesktopFooter";
import MobileFooter from "./MobileFooter";

interface ConnectedPageFooterProps {
    footerInfo?: FooterProps;
    isCheckout?: boolean;
}

const ConnectedPageFooter: React.FC<ConnectedPageFooterProps> = ({ footerInfo, isCheckout }) => {
    const isDesktop = useBreakpoint("xs");

    if (_isEmpty(footerInfo)) {
        return null;
    }

    const footerData = isCheckout ? { bottomRow: footerInfo?.bottomRow || null } : footerInfo;

    if (!footerData || _isEmpty(footerData)) {
        return null;
    }

    return isDesktop ? <DesktopFooter footerInfo={footerData} /> : <MobileFooter footerInfo={footerData} />;
};

const mapStateToProps = (state: RootState): ConnectedPageFooterProps => ({
    footerInfo: NAVIGATION_SELECTORS.getFooterInfo(state),
    isCheckout: isCheckoutSelector(state),
});

export default connect(mapStateToProps)(ConnectedPageFooter);
